<template>
    <button
        v-tippy="t('editorToggleParagraph')"
        :class="[
            buttonState(editor.can().setParagraph(), editor.isActive('paragraph')),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().setParagraph()"
        @click="editor.chain().focus().setParagraph().run()"
    >
        <MdiFormatParagraph class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatParagraph from 'materialdesignicons-vue3/icons/MdiFormatParagraph.js';

    defineExpose({
        name: 'FormatParagraphButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
